import type { ReactNode } from "react";
import classnames from "classnames";

function DetailGridSection({ className, children }: { className?: string; children: ReactNode }) {
  return <div className={classnames("DetailGrid-section", className)}>{children}</div>;
}

export default DetailGridSection;
